import React from 'react'
import { ModalVisibilityProps, openModal, modalVisibility } from 'sb-modal'

import ChangeFrequencyModalView from './ChangeFrequencyModalView/ChangeFrequencyModalView'

import useChangeFrequencyModal, { ChangeFrequencyModalProps } from './util/useChangeFrequencyModal'


const ChangeFrequencyModal: React.FunctionComponent<ChangeFrequencyModalProps & ModalVisibilityProps> = (props) => {
  const { frequencies, frequencyField, onConfirm, onClose } = useChangeFrequencyModal(props)

  return (
    <ChangeFrequencyModalView
      frequencies={frequencies}
      frequencyField={frequencyField}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  )
}

export const openChangeFrequencyModal = (props: ChangeFrequencyModalProps) => {
  openModal('changeFrequencyModal', props)
}

export default modalVisibility('changeFrequencyModal', ChangeFrequencyModal)
